import { render, staticRenderFns } from "./noLayout.vue?vue&type=template&id=bd5b04ce&scoped=true"
import script from "./noLayout.vue?vue&type=script&lang=js"
export * from "./noLayout.vue?vue&type=script&lang=js"
import style0 from "./noLayout.vue?vue&type=style&index=0&id=bd5b04ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd5b04ce",
  null
  
)

export default component.exports